import { render, staticRenderFns } from "./InputFileButton.vue?vue&type=template&id=5d4650b2&"
import script from "./InputFileButton.vue?vue&type=script&lang=js&"
export * from "./InputFileButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports